module.exports = ".opacityIcon{\r\n    opacity: 0.25;\r\n    font-size: 200px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/contact/contact.component.css
// module id = ./src/app/contact/contact.component.css
// module chunks = main